const placeSectionColumnFieldImages = (section, reportPdf) => {
    for (const field of section.Column1.Fields) {
        if (field.Image) {
            reportPdf.addImage(
                (new Image().src = `data:image/jpeg;base64,${field.Value}`),
                field.Format,
                section.Column1.Left, // x
                reportPdf.getCurrentLinePosition(), // y
                field.Width,
                field.Height,
                ''
            );
            reportPdf.incrementCurrentLineBy(field.Height + 10);
        }
    }
};

const placeImages = (reportImages, reportPdf) => {
    for (const image of reportImages) {
        placeImage(image, reportPdf);
    }
};

const placeImage = (reportImage, reportPdf) => {
    reportPdf.addImage(
        (new Image().src = `data:image/jpeg;base64,${reportImage.Value}`),
        reportImage.Format,
        reportImage.X,
        reportImage.Y,
        reportImage.Width,
        reportImage.Height,
        ''
    );
};

export {
    placeSectionColumnFieldImages as PlaceSectionColumnFieldImages,
    placeImages as PlaceImages,
};
